import React from 'react';

export const RefreshIcon: React.FC = () => (
    <svg
        width='16'
        height='16'
        viewBox='134.5 417 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M149.833 419.667V423.667H145.833'
            stroke='currentColor'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M135.167 430.333V426.333H139.167'
            stroke='currentColor'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M136.84 423C137.178 422.045 137.753 421.19 138.51 420.517C139.268 419.844 140.184 419.373 141.172 419.149C142.161 418.926 143.19 418.956 144.163 419.238C145.137 419.519 146.024 420.043 146.74 420.76L149.833 423.667M135.167 426.333L138.26 429.24C138.977 429.957 139.863 430.481 140.837 430.762C141.81 431.044 142.839 431.074 143.828 430.85C144.816 430.627 145.732 430.156 146.49 429.483C147.247 428.81 147.822 427.955 148.16 427'
            stroke='currentColor'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
